import { render, staticRenderFns } from "./NotesCard.vue?vue&type=template&id=e46346d2&scoped=true&"
import script from "./NotesCard.vue?vue&type=script&lang=js&"
export * from "./NotesCard.vue?vue&type=script&lang=js&"
import style0 from "./NotesCard.vue?vue&type=style&index=0&id=e46346d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46346d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VContainer,VSheet,VSubheader})
